import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { technicalEvaluationData } from '../../master/dummayData';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { environment } from '../../../../environments/environment';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
import { Subscription } from 'rxjs';

interface ComplianceRow {
  id: number;
  criteria: string;
  vendors: {
    [key: string]: {
      compliance: string;
      file?: File;
    }
  }
}
@Component({
  selector: 'app-technical-eveluation',
  standalone: false,
  templateUrl: './technical-eveluation.component.html',
  styleUrl: './technical-eveluation.component.scss'
})
export class TechnicalEveluationComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() step: any;
  @Input() id: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() schemeType: string;
  commentForm: FormGroup;
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  vendors = [];
  qualifiedFeild: any;
  criteria: any
  payload: {
    proposal_id: any;
    schemeId: any,
    proposal_name: any;
  };
  JustificationForm: FormGroup;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  apiUrl = environment.APIUrl
  vendorNames: string[] = [];
  criteriaList: any[] = [];
  vendorsData: { [vendorName: string]: any[] } = {};
  vendorStatusMap: { [vendorName: string]: string } = {};
  resId: any
  vendorStatus: { [key: string]: string } = {}; // Holds current status
  evaluationId: any
  vendorsDoc: any
  private subscriptions = new Subscription();
   @Output() generatePDFEmitter = new EventEmitter<any>();
  userID: any;
  constructor(private fb: FormBuilder, private config: PrimeNGConfig, private messageService: MessageService, private route: ActivatedRoute, private api: ApiService) {
    this.commentForm = this.fb.group({
      comment: ['', Validators.required]
    });
          const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const schemeId = params['scheme'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        schemeId: schemeId,
        proposal_name: proposalName
      }
      this.JustificationForm = this.fb.group({
        comment: [''],
      });
      if (this.schemeType != 'tdf' && this.schemeType != 'makeI') {
        this.getStep2();
      }
      this.getStep1();

    });
    this.initializeComplianceData();

  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.isEditable) {
        this.isEditorDisabled = false;
        this.JustificationForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.JustificationForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
      editorReady = false;
  rebuildEditor() {
  this.editorReady = false; // destroy
  setTimeout(() => {
    this.init = this.getTinyInit(); // refresh config
    this.editorReady = true; // recreate editor
  }, 0);
}
getTinyInit(): EditorComponent['init'] {
  return {
    readonly: this.isEditorDisabled
  };
}
  goToNextStep() {
    this.stepCompleted.emit();
  }
  private initializeComplianceData() {

    this.qualifiedFeild = this.criteria.map((criteria, index) => ({
      id: index + 1,
      criteria,
      vendors: this.vendors.reduce((acc, vendor) => {
        acc[vendor] = { compliance: 'No' };
        return acc;
      }, {} as { [key: string]: { compliance: string; file?: File } })
    }));

  }

  getStep1() {
    if (this.schemeType === 'makeI' || this.schemeType == 'tdf') {
      const endpoint = this.schemeType == 'tdf' ? `/tdf/evaluation/tpr/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}` : `/make1/upload/dpr/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}&scheme=${this.payload.schemeId}`;

      const sub = this.api.getAPI(endpoint).subscribe((res: any) => {
        this.resId = res.id;
        this.JustificationForm.patchValue({
          comment: res.justification || ''
        });

        const vendorsData = res.da || res.vendor || {};
        const vendorMap = new Map();
        const vendorStatusMap = {};
        const vendorsDocMap: any = {};

        Object.keys(vendorsData).forEach((vendorName) => {
          const entry = vendorsData[vendorName]?.[0] || {};

          const document = entry?.document || null;
          const bid_document = entry?.bid_document || null;
          const document_flag = entry?.document_flag === true || entry?.document_flag === 'true';
          const evaluation_id = entry?.id || null;
          const daId = entry?.da?.id || null;

          // Vendor status
          vendorStatusMap[vendorName] = entry?.vendor_status || '';

          // Doc map
          vendorsDocMap[vendorName] = {
            document,
            bid_document,
            document_flag,
            compliance: entry?.vendor_status || '',
            evaluation_id
          };

          // For table display
          vendorMap.set(vendorName, {
            name: vendorName,
            entries: [
              {
                evaluationId: evaluation_id,
                proposalStep: entry?.proposal_step || this.id,
                document,
                bid_document,
                document_flag,
                selectedFile: null,
                daId,
                criteriaName: 'DPR'
              },
              {
                evaluationId: evaluation_id,
                proposalStep: entry?.proposal_step || this.id,
                document,
                bid_document,
                document_flag,
                selectedFile: null,
                daId,
                criteriaName: 'Commercial Bid'
              }
            ]
          });
        });

        // Prepare DPR criteria block
        const qualifiedField = [
          {
            id: 1,
            criteria: 'DPR',
            vendors: vendorsDocMap
          },
          {
            id: 1,
            criteria: 'Commercial Bid ',
            vendors: vendorsDocMap
          }
        ];

        this.vendorNames = Array.from(vendorMap.keys());
        this.vendorsDoc = Array.from(vendorMap.values());
        this.vendorStatusMap = vendorStatusMap;
        this.qualifiedFeild = qualifiedField;
        this.criteriaList = ['DPR', 'Commercial Bid'];
      });
      this.subscriptions.add(sub);
    } else {
      // Existing non-make logic unchanged
      let url = this.schemeType === 'idex'
        ? `/idex/receipt/bids/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`
        : `/revenue/technical-evaluation/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`;

      const sub = this.api.getAPI(url).subscribe((res: any) => {
        this.resId = res.id;
        this.JustificationForm.patchValue({
          comment: res.justification || ''
        });

        this.vendorsData = res?.vendors || {};
        this.vendorNames = Object.keys(this.vendorsData);

        const criteriaMap = new Map<number, string>();

        this.vendorNames.forEach(vendor => {
          const entries = this.vendorsData[vendor] || [];
          entries.forEach((entry: any) => {
            if (entry.criteria && !criteriaMap.has(entry.criteria.id)) {
              criteriaMap.set(entry.criteria.id, entry.criteria.name);
            }
          });
        });

        this.vendorStatusMap = {};
        this.vendorNames.forEach(vendor => {
          const entries = this.vendorsData[vendor] || [];
          const lastStatusEntry = [...entries].reverse().find(entry => entry.vendor_status);
          this.vendorStatusMap[vendor] = lastStatusEntry?.vendor_status || '';
        });

        this.qualifiedFeild = Array.from(criteriaMap.entries()).map(([criteriaId, criteriaName], index) => {
          const vendorValues: any = {};

          this.vendorNames.forEach(vendor => {
            const vendorEntries = this.vendorsData[vendor] || [];
            const entry = vendorEntries.find((e: any) => e.criteria?.id === criteriaId) || null;

            vendorValues[vendor] = {
              document: entry?.document || null,
              document_flag: entry?.document_flag === true || entry?.document_flag === 'true' || false,
              compliance: entry?.vendor_status || '',
              evaluation_id: entry?.id || null
            };
          });

          return {
            id: index + 1,
            criteria: criteriaName,
            criteria_id: criteriaId,
            vendors: vendorValues
          };
        });

        this.criteriaList = Array.from(criteriaMap.values());
      });
      this.subscriptions.add(sub);
    }
  }

 onVendorStatusChange(vendor: string, status: string): void {
    // Find the first row that has the vendor's evaluation_id
    const rowWithEvaluation = this.qualifiedFeild.find(row =>
      row.vendors[vendor] && row.vendors[vendor].evaluation_id
    );

    if (!rowWithEvaluation) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: `No evaluation found for vendor: ${vendor}`
      });
      return;
    }

    const evaluationId = rowWithEvaluation.vendors[vendor].evaluation_id;
    let vendorStatus
    if (status == 'Qualified') {
      vendorStatus = 'Qualify'
    } else {
      vendorStatus = 'Disqualify'
    } let url;
    if (this.schemeType == 'makeI') {
      url = `/make1/upload/dpr/`
    } else if (this.schemeType == 'tdf') {
      url = `/tdf/evaluation/tpr/`
    } else if(this.schemeType == 'idex'){
     url = `/idex/technical-evaluation/` 
    }
    else {
      url = `/revenue/technical-evaluation/`
    }

    const sub = this.api.putAPI(url, {
      vendor_eval_id: evaluationId,
      vendor_status: vendorStatus
    }).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Status updated for ${vendor}`
        });

        // Refresh data once
        this.getStep1();
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `Failed to update status for ${vendor}`
        });
      }
    });
    this.subscriptions.add(sub);
  }


  isVendorQualified(vendor: string): boolean {
    console.log(vendor, this.qualifiedFeild)
    return this.qualifiedFeild.every(row => row.vendors[vendor]?.compliance === 'Qualified');
  }

  isVendorDisqualified(vendor: string): boolean {
    return this.qualifiedFeild.some(row => row.vendors[vendor]?.compliance === 'Disqualified');
  }

  getEvaluationId(vendorName: string, criteriaId: number): number | null {
    const match = this.qualifiedFeild.find(row => row.criteria_id === criteriaId);
    return match?.vendors?.[vendorName]?.evaluation_id || null;
  }
 
  getStep2() {
    let endpoint = '';
    const isMake1 = this.schemeType?.toLowerCase() === 'makei';
    const isIdex = this.schemeType == 'idex';

    if (isMake1) {
      endpoint = `/make1/upload/dpr/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}&scheme=${this.payload.schemeId}`;
    } else if (isIdex) {
      endpoint = `/idex/receipt/bids/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    } else {
      endpoint = `/revenue/technical-evaluation/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    }

    const sub = this.api.getAPI(endpoint).subscribe((res: any) => {
      const vendorsData = isMake1 ? res || {} : res?.vendors || {};
      const vendorMap = new Map();

      Object.keys(vendorsData).forEach((vendorName: string) => {
        const items = vendorsData[vendorName];

        const entries = items.map((item: any) => ({
          evaluationId: item.id,
          vendorId: item.vendor?.id || null,
          criteriaId: item.criteria?.id || null,
          criteriaName: isMake1 ? 'DPR' : item.criteria?.name,
          daId: item.da?.id || null,
          proposalStep: item.proposal_step,
          document: item.document,
          document_flag: item.document_flag,
          selectedFile: null
        }));
        vendorMap.set(vendorName, {
          name: vendorName,
          entries: entries
        });
      });

      this.vendorsDoc = Array.from(vendorMap.values());
    });
    this.subscriptions.add(sub);
  }

  onSubmit() {
    const justification = this.JustificationForm.get('comment')?.value;
    let url;
    if (this.schemeType == 'makeI') {
      url = `/make1/upload/dpr/${this.resId}/`
    } else if (this.schemeType == 'tdf') {
      url = `/tdf/evaluation/tpr/${this.resId}/`
    }else if(this.schemeType == 'idex') {
      url = `/idex/technical-evaluation/${this.resId}/`
    } else {
      url = `/revenue/technical-evaluation/${this.resId}/`
    }
    const sub = this.api.putAPI(url, {
      justification: justification,
    }).subscribe({
      next: () => {
        this.getStep1()
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Justification submitted`
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `Failed to submit justification`
        });
      }
    });
    this.subscriptions.add(sub);
  }
  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.payload.proposal_name },
        { key: "Comments", value: this.JustificationForm.get('comment')?.value },

      ]
    };
    this.generatePDFEmitter.emit(payload);
  }
}